// extracted by css-extract-rspack-plugin
export default {"select":"UiDropdown_select_j5cGy","placeholder":"UiDropdown_placeholder_DVIfS","error":"UiDropdown_error_S0Fy1"};